/* unplugin-vue-components disabled */import { render } from "./userLogin.vue?vue&type=template&id=0e672eb2&scoped=true&ts=true"
import script from "./userLogin.vue?vue&type=script&lang=ts"
export * from "./userLogin.vue?vue&type=script&lang=ts"

import "./userLogin.vue?vue&type=style&index=0&id=0e672eb2&scoped=true&lang=css"
import "./userLogin.vue?vue&type=style&index=1&id=0e672eb2&lang=scss"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e672eb2"],['__file',"src/components/nav-aside/cpns/userLogin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e672eb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e672eb2', __exports__)) {
    console.log('reload')
    api.reload('0e672eb2', __exports__)
  }
  
  module.hot.accept("./userLogin.vue?vue&type=template&id=0e672eb2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0e672eb2', render)
  })

}


export default __exports__